<template>
  <form action="#" method="post" class="user-form login-form">
    <input
      type="text"
      :class="{ invalid: !$v.phone.required && $v.phone.$dirty }"
      v-model="phone"
      name="phone"
      class="user-input"
      :placeholder="$t('phone_or_login_placeholder')"
      required
    />
    <div class="error" v-if="!$v.phone.required && $v.phone.$dirty">
      <i>{{ $t("phone_required") }}</i>
    </div>
    <div class="password">
      <input
        :type="type ? 'password' : 'text'"
        :class="{ invalid: !$v.password.required && $v.password.$dirty }"
        v-model="password"
        name="password"
        class="user-input"
        :placeholder="$t('password_placeholder')"
        required
      /><span @click="type = !type">👁</span>
    </div>
    <div class="error" v-if="!$v.password.required && $v.password.$dirty">
      <i>{{ $t("password_required") }}</i>
    </div>
    <div class="error" v-if="!$v.password.minLength && $v.password.$dirty">
      <i v-cyr2lat="lang">{{
        $t("password_min_length", { min: $v.password.$params.minLength.min })
      }}</i>
    </div>
    <router-link to="/forgot" class="log-password"
      ><i>{{ $t("forgot_password") }}</i></router-link
    >
    <div class="user-button">
      <label class="user-form-sub">
        <input type="submit" @click.prevent="submitLogin" /><span>{{
          $t("login")
        }}</span>
        <i class="fa-out"></i>
      </label>
      <!-- Self-registration disabled for employee training -->
    </div>
    <!--    <div class="social-login">-->
    <!--      <h3>Вход через</h3>-->
    <!--      <div class="social-login-list">-->
    <!--        <a href="#" class="login-facebook"><i class="fa-facebook"></i> Facebook</a>-->
    <!--        <a href="#" class="login-telegram"><i class="fa-telegram"></i> Telegram</a>-->
    <!--      </div>-->
    <!--    </div>-->
  </form>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      phone: "",
      password: "",
      type: true,
    };
  },
  validations: {
    phone: {
      required,
    },
    password: {
      required,
      minLength: minLength(6),
    },
  },

  created() {
    this.phone = this.$store.getters.getTelNumber;
  },
  methods: {
    async submitLogin() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      const data = {
        phone: this.phone.replace(/-|\s/g, "").replace(/[{()}]/g, ""),
        password: this.password,
      };
      await this.$store.dispatch("login", data);
      if (this.$store.getters.getIsAuthenticated) {
        await this.$router.push("/");
      }
    },
    yourCallbackFunction(user) {
      // gets user as an input
      // id, first_name, last_name, username,
      // photo_url, auth_date and hash
      console.log(user);
    },
  },
  computed: {
    lang() {
      return this.$store.getters.lang;
    },
  },
};
</script>
